import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  Media: {
    height: '100%',
    width: '100%',
  },

  li: {
    lineHeight: '30px',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    color: 'black',
  },

  mainWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 50px)',
  },

  leftWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    width: '100%',
  },

  acceptArea: {
    fontSize: '14.3px',
    lineHeight: '24px',
    fontWeight: '400',
    opacity: 0.75,
    margin: '12px 0',
    color: theme.palette.primary.dark,
  },

  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none !important',
    fontWeight: '500',
  },

  insideH1: {
    marginBottom: 15,
    fontSize: '180%',
    fontWeight: 'normal',
    lineHeight: '30px',
  },

  insideBody: {
    marginBottom: 0,
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '18px',
  },

  logoImage: {
    // width: '100%',
    height: '80px',
    margin: 0,
    padding: 0,
  },

  formBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '480px',
  },

  paperWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '30px',
    width: '100%',
    height: '100%',
  },

  connectBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '8px',
    width: '480px',
  },

  connectionBox: {
    height: '276px',
    width: '100%',
    border: 'solid 1px #DBE5DE',
    borderRadius: '8px',
    padding: '16px',
  },

  iconConnection: {
    fontSize: '48px',
    color: theme.palette.primary.main,
  },

  textBody: {
    fontSize: '16px',
    color: '#5C5F5D',
    textAlign: 'center',
    margin: 0,
  },

  textFoot: {
    fontSize: '12px',
    color: '#5C5F5D',
    textAlign: 'left',
  },

  formTitle: {
    marginTop: 0,
    marginBottom: 0,
    width: '100%',
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '32px',
    color: '#002116 !important',
  },

  formSubTitle: {
    marginTop: 0,
    marginBottom: 5,
    width: '100%',
    fontWeight: '400',
    fontSize: '14.5px',
    lineHeight: '24px',
  },
}))

export { useStyles }
